import ResetStyles from './reset'
import MarkdownStyles from './markdown'
import PrismStyles from './prism'

export default {
  ResetStyles,
  MarkdownStyles,
  PrismStyles,
}
